import Icon from "@components/Atoms/Icon";
import t from "@ext/localization/locale/translate";
import { useSetting } from "@ext/settings/logic/hooks";
import Theme from "@ext/Theme/Theme";
import { DropdownMenuItem } from "@ui-kit/Dropdown";

export const ThemeMenuItem = () => {
	const [theme, setTheme] = useSetting("general.theme");
	const isDark = theme === Theme.dark;

	return (
		<DropdownMenuItem onSelect={() => setTheme(isDark ? Theme.light : Theme.dark)}>
			<Icon code={isDark ? "moon" : "sun"} />
			{t("change-theme")}
		</DropdownMenuItem>
	);
};
